import React from 'react';
import PropTypes from 'prop-types';
import { DropDownBtn } from '../../elements-dropdown/dropdown-btn-v2';
import { List } from '../../elements-dropdown/dropdown-list-v2';
import { FormattedMessage } from 'react-intl';
import { ArrowDownSmall } from '../../shared-components/icons';

const SpaceInfo = ({ spaces = {}, show, hideArrow, data: id, isMobile, index, darkMode }) => {
  const { title = '', street = '' } = spaces[id] || {};
  if (isMobile) {
    return (
      <option
        key={`spaces-key-${index}`}
        value={id}
        data-value={id}
      >
        { title }
      </option>
    );
  }
  return (
    <div
      key={`spaces-key-${index}`}
      className="flex space-between middle"
    >
      <div className="full-width ellipsis">
        <div className="list-title"><h6 className="ellipsis">{title}</h6></div>
        <div className="text-gray ellipsis text-small">{street}</div>
      </div>
      {
        hideArrow ?
          null :
          <div className={`text-xl flex-one ${darkMode ? 'text-white' : ''}`}>
            <ArrowDownSmall />
          </div>
      }
    </div>
  );
};

export class SpaceSelector extends React.Component {
  render () {
    const {
      spacesClickFn,
      spaces,
      selectedSpaceId,
      inputRef,
      buttonClass,
      darkMode = false,
      containerClassName = ''
    } = this.props;
    const spaceIds = Object.keys(spaces);
    return (
      <DropDownBtn
        buttonClassName={`space-dropdown-button${darkMode ? ' no-outline dark-mode' : ''} ${buttonClass || ''}`}
        containerClassName={containerClassName}
        buttonChildren={
          <div
            ref={
              ref => {
                if (inputRef) inputRef(ref);
                this.spaceRef = ref;
                return this.spaceRef;
              }
            }
            data-value={selectedSpaceId}
          >
            <SpaceInfo
              data={selectedSpaceId}
              spaces={spaces}
              darkMode={darkMode}
            />
          </div>
        }
      >
        <List
          listKey="host-spaces"
          listClick={spacesClickFn}
          listData={spaceIds}
          listClassName="space-list"
          selectedValue={selectedSpaceId}
        >
          <SpaceInfo
            hideArrow
            spaces={spaces}
          />
        </List>
      </DropDownBtn >
    );
  }
}

SpaceSelector.propTypes = {
  spacesClickFn: PropTypes.func,
  spaces: PropTypes.object,
  selectedSpaceId: PropTypes.string,
  inputRef: PropTypes.func,
  buttonClass: PropTypes.string,
  darkMode: PropTypes.bool,
  containerClassName: PropTypes.string
};

SpaceInfo.propTypes = {
  data: PropTypes.string,
  show: PropTypes.bool,
  spaces: PropTypes.object,
  hideArrow: PropTypes.bool,
  isMobile: PropTypes.bool,
  index: PropTypes.string,
  darkMode: PropTypes.bool
};
